/**
 * Shared TanStack Query key roots for the V2 email caches that
 * `useArchiveEmails`, `useDeleteEmails`, and `useUnarchiveEmails` mutate.
 *
 * `invalidateEmailCaches` in `frontend/web/src/lib/supabase-utils.ts` invalidates
 * by these exact prefixes; the constants pin the spelling so a rename
 * here can't silently break invalidation.
 */

export const QK_EMAIL_INDEX = 'email-index' as const;
export const QK_EMAIL_METADATA_BATCH = 'email-metadata-batch' as const;
export const QK_EMAIL_FILTER_COUNTS = 'email-filter-counts' as const;
/** Root of the saved-view counter cache. The 'v2-correspondence' suffix busts
 *  cached numbers across the PUB-885 PR 3b semantic shift (counter switched
 *  from email_metadata rows to correspondences). Key shape:
 *  `[QK_SAVED_VIEW_COUNTS, organizationId, userId, sortedViewIds]`. */
export const QK_SAVED_VIEW_COUNTS = 'saved-view-counts-v2-correspondence' as const;
